module.exports = __webpack_public_path__ + "img/messenger.9f84e333.svg";